import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { Box } from '@mui/material';

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        
        <Box className="min-h-screen bg-gray-50">
            {/* Navbar fixe en haut */}
            <Navbar onMenuClick={toggleSidebar} />

            {/* Container principal avec Sidebar et Contenu */}
            <Box className="flex h-[calc(100vh-64px)]"> {/* 64px est la hauteur de la Navbar */}
                {/* Sidebar */}
                <Box
                    className={`
                        ${isSidebarOpen ? 'w-64' : 'w-0'}
                        transition-all duration-300 ease-in-out
                        fixed left-0 h-full
                        bg-white
                        shadow-lg
                        z-40
                    `}
                >
                    <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar}  />
                </Box>

                {/* Contenu principal */}
                <Box
                    className={`
                        flex-1
                        transition-all duration-300 ease-in-out
                        ${isSidebarOpen ? 'ml-72' : 'ml-16'}
                        overflow-auto
                        bg-gray-50
                    `}
                >
                    {children}
                </Box>
            </Box>
        </Box>        
    );
};

export default MainLayout; 